(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-dressers"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const cleanedCollection = /\/collections\/(bedroom-sets|sectionals)(?:[/?#]|$)/.test(window.location.pathname + '/');

    if (!cleanedCollection) {
      return;
    }

    const normalizeTitle = (value) =>
      value
        .replace(/^(Atelier Forn|Mavenwood|Norden Co\.|Holmsby|Halden|Westerly)\s+/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

    const dedupeCards = () => {
      const seen = new Set();

      document.querySelectorAll('li.product-grid__item').forEach((card) => {
        const title = card.querySelector('a[href*="/products/"]')?.textContent || '';
        const key = normalizeTitle(title);

        if (!key) {
          return;
        }

        if (seen.has(key)) {
          card.remove();
          return;
        }

        seen.add(key);
      });
    };

    dedupeCards();

    const grid = document.querySelector('#ResultsList') || document.body;
    const observer = new MutationObserver(dedupeCards);
    observer.observe(grid, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const cleanedCollection = /\/collections\/(bedroom-sets|sectionals)(?:[/?#]|$)/.test(window.location.pathname + '/');

    if (!cleanedCollection) {
      return;
    }

    const dedupeCards = () => {
      const seen = new Set();

      document.querySelectorAll('li.product-grid__item').forEach((card) => {
        // Similar titles can describe different products or configurations.
        const key = card.dataset.productId;

        if (!key) {
          return;
        }

        if (seen.has(key)) {
          card.remove();
          return;
        }

        seen.add(key);
      });
    };

    dedupeCards();

    const grid = document.querySelector('#ResultsList') || document.body;
    const observer = new MutationObserver(dedupeCards);
    observer.observe(grid, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
